<template>
  <p class="mx-auto leading-4 tracking-wider w-full">
    <slot />
  </p>
</template>
